import { NodeConfig, TreeGraphData } from '@antv/g6';
import { FormFieldWidget, ModelFieldType, SPI, ViewType, Widget } from '@kunlun/dependencies';
import { cloneDeep, isNil } from 'lodash-es';
import MindMap from './MindMap.vue';
import { actionBarHeight, conditionRowHeight } from './nodes';
import {
  createActivityTypeData,
  createConditionData,
  createPolicyData,
  createRightsInfoData,
  createSimpleConditionData,
  rootNodeData
} from './templateData';
import { queryPromotionType } from '../../form/MindMap/services';

@SPI.ClassFactory(
  FormFieldWidget.Token({
    viewType: ViewType.Detail,
    ttype: ModelFieldType.ManyToOne,
    widget: 'MindMap',
    multi: false
  })
)
export class DetailM2oMindMapFieldWidget extends FormFieldWidget {
  @Widget.Reactive()
  get merchBill() {
    return this.formData.merchBill;
  }

  @Widget.Reactive()
  treeData!: '';

  public initialize(props) {
    super.initialize(props);
    this.setComponent(MindMap);
    return this;
  }
  @Widget.Reactive()
  public baseData: {
    promotionTypeEnumList: null | { name: string; value: string }[];
  } = {
    promotionTypeEnumList: null
  };

  @Widget.Watch('formData.promotionDesignJson', { immediate: true })
  watchJson(val) {
    if (val) {
      const json = JSON.parse(val);
      json.id += '';

      let treeData: any = rootNodeData(json);

      // 第一层
      const copyJson = cloneDeep(json);
      // copyJson.children = [];
      // 前置条件
      if (copyJson.hasPrecondition) {
        const copy = cloneDeep(copyJson);
        copy.children = [];
        treeData.jsonData = copy;
        treeData.actionBar.switchAction.open = true;
        const conditionNode = createConditionData(true, copy, true) as NodeConfig & Record<string, any>;
        Array(conditionNode.jsonData.conditions.length - 1)
          .fill('')
          .forEach((i) => {
            conditionNode.y! -= conditionRowHeight / 2;
            conditionNode.size![1] += conditionRowHeight;
            conditionNode.anchorPoints = [
              [0, (conditionNode.size![1] - actionBarHeight) / 2 / conditionNode.size![1]],
              [1, (conditionNode.size![1] - actionBarHeight) / 2 / conditionNode.size![1]]
            ];
          });
        treeData.children = [conditionNode];
        this.parseTreeData(copyJson, treeData.children[0], 2);
      } else {
        // 其他层
        this.parseTreeData(copyJson, treeData, 2);
      }

      this.treeData = treeData;
    }
  }
  protected async mounted() {
    try {
      super.mounted();
      const res = await queryPromotionType(this.model);
      this.baseData.promotionTypeEnumList = res?.promotionTypeEnumList?.map(item => { return { label:item.displayName,value:item.value}})
    } catch (error) {
      console.error(error)
    }
  }
  // 逆向解析树结构
  parseTreeData(json, node, level?: number) {
    const copyJson = cloneDeep(json);

    copyJson.children.forEach((i, index) => {
      let child: TreeGraphData;
      i.id += '';
      i.parentId += '';
      // 第二层
      if (level === 2) {
        i.policyInfo.name = i.name;
        child = createPolicyData(i.parentId, i);
        if (!isNil(i.policyInfo.accountTimeRule)) {
          if (!isNil(i.policyInfo.paymentDays)) {
            i.policyInfo.paymentDays += '';
          } else {
            i.policyInfo.paymentDays = '';
          }
        } else {
          i.policyInfo.accountTimeRule = '';
          i.policyInfo.paymentDays = '';
          i.policyInfo.accountDate = '';
        }

        const copy = cloneDeep(i);
        child.jsonData = copy;
        // 前置条件
        if (i.hasPrecondition) {
          copy.children = [];
          (child.actionBar as any).switchAction.open = true;
          const conditionNode = createConditionData(true, copy, true) as NodeConfig & Record<string, any>;
          Array(conditionNode.jsonData.conditions.length - 1)
            .fill('')
            .forEach((i) => {
              conditionNode.y! -= conditionRowHeight / 2;
              conditionNode.size![1] += conditionRowHeight;
              conditionNode.anchorPoints = [
                [0, (conditionNode.size![1] - actionBarHeight) / 2 / conditionNode.size![1]],
                [1, (conditionNode.size![1] - actionBarHeight) / 2 / conditionNode.size![1]]
              ];
            });
          // @ts-ignore
          child.children = [conditionNode];
          node.children.push(child);
          this.parseTreeData(i, node.children[index].children[0], 3);
        } else {
          node.children.push(child);
          this.parseTreeData(i, node.children[index], 3);
        }
      }
      // 第三层
      else if (level === 3) {
        const copy = cloneDeep(i);
        copy.children = [];
        child = createActivityTypeData(i.parentId, copy);

        // 前置条件
        if (i.hasPrecondition) {
          (child.jsonData as any) = copy;
          (child.actionBar as any).switchAction.open = true;
          const conditionNode = createConditionData(true, copy, true) as NodeConfig & Record<string, any>;
          Array(conditionNode.jsonData.conditions.length - 1)
            .fill('')
            .forEach((i) => {
              conditionNode.y! -= conditionRowHeight / 2;
              conditionNode.size![1] += conditionRowHeight;
              conditionNode.anchorPoints = [
                [0, (conditionNode.size![1] - actionBarHeight) / 2 / conditionNode.size![1]],
                [1, (conditionNode.size![1] - actionBarHeight) / 2 / conditionNode.size![1]]
              ];
            });
          // @ts-ignore
          child.children = [conditionNode];

          // 门槛规则
          let ruleConditionNode;
          if (copy.optionType !== 'DIRECT_DESCENT') {
            ruleConditionNode = createConditionData(false, copy, true) as NodeConfig & Record<string, any>;
            Array(ruleConditionNode.jsonData.effectConditions.length - 1)
              .fill('')
              .forEach((i) => {
                ruleConditionNode.y! -= conditionRowHeight / 2;
                ruleConditionNode.size![1] += conditionRowHeight;
                ruleConditionNode.anchorPoints = [
                  [0, (ruleConditionNode.size![1] - actionBarHeight) / 2 / ruleConditionNode.size![1]],
                  [1, (ruleConditionNode.size![1] - actionBarHeight) / 2 / ruleConditionNode.size![1]]
                ];
              });
          } else {
            ruleConditionNode = createSimpleConditionData(copy) as NodeConfig & Record<string, any>;
          }

          // @ts-ignore
          child.children![0].children = [ruleConditionNode];
          // 权益信息
          const rightsInfoNode = createRightsInfoData(copy);
          rightsInfoNode.activityType = copy.optionType;
          if (['REDUCTION_AMOUNT', 'DISCOUNT_RATE'].includes(copy.equityInformationRule.reductionOption)) {
            rightsInfoNode.actionBar.linkAction = false;
            rightsInfoNode.actionBar.settingAction = true;
          }
          // 满赠
          if (copy.optionType === 'FULL_GWP') {
            // 权益类型为"料号满A赠A"或"货号满A赠A"
            if (['ITEM_FULL_A_TO_A', 'ARTICLE_FULL_A_TO_A'].includes(copy.equityInformationRule.giftOption)) {
              rightsInfoNode.actionBar.linkAction = false;
            } else {
              rightsInfoNode.actionBar.linkAction = true;
            }
          } else {
            rightsInfoNode.actionBar.linkAction = false;
          }
          child.children![0].children![0].children = [rightsInfoNode];
        } else {
          // 门槛规则
          let ruleConditionNode;
          if (copy.optionType !== 'DIRECT_DESCENT') {
            ruleConditionNode = createConditionData(false, copy, true) as NodeConfig & Record<string, any>;
            Array(ruleConditionNode.jsonData.effectConditions.length - 1)
              .fill('')
              .forEach((i) => {
                ruleConditionNode.y! -= conditionRowHeight / 2;
                ruleConditionNode.size![1] += conditionRowHeight;
                ruleConditionNode.anchorPoints = [
                  [0, (ruleConditionNode.size![1] - actionBarHeight) / 2 / ruleConditionNode.size![1]],
                  [1, (ruleConditionNode.size![1] - actionBarHeight) / 2 / ruleConditionNode.size![1]]
                ];
              });
          } else {
            ruleConditionNode = createSimpleConditionData(copy) as NodeConfig & Record<string, any>;
          }
          // @ts-ignore
          child.children = [ruleConditionNode];
          // 权益信息
          const rightsInfoNode = createRightsInfoData(copy);
          rightsInfoNode.activityType = copy.optionType;
          if (['REDUCTION_AMOUNT', 'DISCOUNT_RATE'].includes(copy.equityInformationRule.reductionOption)) {
            rightsInfoNode.actionBar.linkAction = false;
            rightsInfoNode.actionBar.settingAction = true;
          }
          // 满赠
          if (copy.optionType === 'FULL_GWP') {
            // 权益类型为"料号满A赠A"或"货号满A赠A"
            if (['ITEM_FULL_A_TO_A', 'ARTICLE_FULL_A_TO_A'].includes(copy.equityInformationRule.giftOption)) {
              rightsInfoNode.actionBar.linkAction = false;
            } else {
              rightsInfoNode.actionBar.linkAction = true;
            }
          } else {
            rightsInfoNode.actionBar.linkAction = false;
          }
          child.children![0].children = [rightsInfoNode];
        }

        node.children.push(child);
      }
    });
  }
}
